<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/mouse-events-have-key-events -->
<div class="landing-page">
	<nav
		fxLayout="row"
		fxLayoutAlign="end center"
		fxLayoutGap="15px"
		style="height: 84px; position: absolute; top: 0; right: 0; margin-right: 24px; z-index: 1"
	>
		<div class="spacer"></div>
		<button
			type="button"
			mat-button
			id="login-btn"
			(click)="login()"
			class="mat-button--white"
		>
			<span>{{ 'landing.login' | translate }}</span>
		</button>
		<a
			mat-raised-button
			id="sign-up"
			color="primary"
			[routerLink]="['onboarding']"
			class="get-started-button"
		>
			<div class="get-started-button__content">
				<span>{{ 'landing.get-started' | translate }}</span>
				<fa-icon [icon]="faArrowRight" size="sm"></fa-icon>
			</div>
		</a>
	</nav>

	<header class="landing-page__banner landing-page__banner--top">
		<div class="landing-page__banner--top-inner">
			<div class="logo">
				<img
					src="assets/images/mp-logo-home.svg"
					alt="Global Data Marketplace Logo"
					class="w-4/5 logo--desktop"
				/>
				<img
					src="assets/images/marketplace-logo-vertical.svg"
					alt="Global Data Marketplace Logo"
					class="w-4/5 logo--mobile"
				/>
			</div>
			<h1 class="responsive-text--large">
				<span class="cdk-visually-hidden">Global Data Marketplace</span>
				{{ 'landing.enabling' | translate }}
			</h1>
		</div>
	</header>

	<main>
		<div class="landing-page__content-wrapper--top">
			<div
				class="landing-page__content-inner-wrapper landing-page__content-inner-wrapper--ll"
			>
				<div class="landing-page__content">
					<h2 class="cdk-visually-hidden">{{ 'landing.marketplace-overview' | translate }}</h2>
					<div class="responsive-text--medium">
						{{ 'landing.welcome-to-marketplace' | translate }}
					</div>

					<hr class="divider divider--light" />
					<h2 class="cdk-visually-hidden">{{ 'landing.marketplace-features' | translate }}</h2>

					<ul class="landing-page__card-row">
						<li class="landing-page__card">
							<div class="icon">
								<img
									src="assets/images/project_logo.png"
									alt="UDL Logo"
									width="40px"
								/>
							</div>
							<div class="landing-page__card-title">{{ 'landing.udl-connected' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.udl-connected-desc' | translate }}
							</p>
						</li>
						<li class="landing-page__card">
							<fa-icon class="icon" [icon]="faLock"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.confidence' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.confidence-desc' | translate }}
							</p>
						</li>
						<li class="landing-page__card">
							<fa-icon class="icon" [icon]="faCogs"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.api' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.api-desc' | translate }}
							</p>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<section class="landing-page__video">
			<h2 class="cdk-visually-hidden">{{ 'landing.marketplace-video' | translate }}</h2>
			<div class="landing-page__video-inner">
				<iframe
					width="100%"
					height="100%"
					src="https://www.youtube.com/embed/zKJGfAq0m78"
					loading="lazy"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</div>
		</section>

		<div class="landing-page__content-wrapper--middle">
			<div
				class="landing-page__content-inner-wrapper landing-page__content-inner-wrapper--lr"
			>
				<div class="landing-page__content">
					<h2 class="cdk-visually-hidden">{{ 'landing.transaction-features' | translate }}</h2>
					<ul class="landing-page__card-grid">
						<li class="landing-page__card landing-page__card--3">
							<fa-icon class="icon" [icon]="faCommentsDollar"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.transactions' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.transactions-desc' | translate }}
							</p>
						</li>

						<li class="landing-page__card landing-page__card--3">
							<fa-icon class="icon" [icon]="faCreditCard"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.ach-and-credit-cards' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.ach-and-credit-cards-desc' | translate }}
							</p>
						</li>
						<li class="landing-page__card landing-page__card--6">
							<fa-icon class="icon" [icon]="faHandshake"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.immediate-payments' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.immediate-payments-desc' | translate }}
							</p>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<app-how-it-works></app-how-it-works>

		<div class="landing-page__content-wrapper--bottom">
			<div
				class="landing-page__content-inner-wrapper landing-page__content-inner-wrapper--rl"
			>
				<div class="landing-page__content">
					<h2 class="cdk-visually-hidden">{{ 'landing.additional-features' | translate }}</h2>
					<ul class="landing-page__card-grid">
						<li class="landing-page__card landing-page__card--3">
							<fa-icon class="icon" [icon]="faTachometerAlt"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.dashboards' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.dashboards-desc' | translate }}
							</p>
						</li>

						<li class="landing-page__card landing-page__card--3">
							<fa-icon class="icon" [icon]="faChartLine"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.market-analytics' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.market-analytics-desc' | translate }}
							</p>
						</li>

						<li class="landing-page__card landing-page__card--6">
							<fa-icon class="icon" [icon]="faPeopleGroup"></fa-icon>
							<div class="landing-page__card-title">{{ 'landing.inclusive' | translate }}</div>
							<p class="landing-page__card-description">
								{{ 'landing.inclusive-desc' | translate }}
							</p>
						</li>
					</ul>

					<!-- <div class="p-8 mb-10">
						<h2 class="cdk-visually-hidden">Featured Marketplace Vendors</h2>
						<app-logo-row [images]="providerLogos"></app-logo-row>
					</div> -->
				</div>
			</div>
		</div>

		<div class="landing-page__banner--bottom-container">
			<section class="landing-page__banner landing-page__banner--bottom">
				<div class="responsive-text--large text-center">
					{{ 'landing.getting-data' | translate }}
				</div>
				<a
					type="button"
					class="get-started-button"
					mat-raised-button
					color="primary"
					[routerLink]="['onboarding']"
				>
					<div class="get-started-button__content">
						<span>{{ 'landing.get-started' | translate }}</span>
						<fa-icon [icon]="faArrowRight" size="sm"></fa-icon>
					</div>
				</a>
			</section>
		</div>
	</main>
	<app-landing-page-footer></app-landing-page-footer>
</div>
